import React from "react"
import { Link } from "gatsby"

const SectionCta = () => (
  <section className="ctaband">
    <div className="wrap">
      <h2>Know your CJR-X starting point</h2>
      <p>
        Our team will walk through your joint replacement episodes and where
        your largest opportunities are.
      </p>
      <div className="cta-row">
        <Link className="cta blue" to="/contact-us/">
          Speak with an Expert
        </Link>
      </div>
    </div>
  </section>
)

export default SectionCta
